import EditCategoryPage from "./EditCategoryPage";

export default EditCategoryPage;
